<template>
  <!-- 个人中心首页 -->
  <div>
    <div class="center">
      <!-- 左边列表 -->
      <!-- 面包屑 -->

      <!-- 右边详情 -->
      <div class="right">
        <div class="header">
          <div class="infos">
            <div class="img">
              <img src="../../assets/zxx_img/userlogo.png" alt="" />
            </div>

            <div class="info">
              <div class="concat" style="margin-bottom: 10px">
                <div class="names" v-if="status == '已认证'">{{ record.companyName }}</div>
                <div
                  v-if="status == '已认证' && record.lastApplyStatus == 0"
                  class="verification verification-under">
                  <i class="el-icon-warning"></i>
                  审核中，点击
                  <el-button type="text" @click="torenzheng('new')">查看详情</el-button>
                </div>
                <div
                  v-if="status == '已认证' && record.lastApplyStatus == 2"
                  class="verification verification-refuse">
                  <i class="el-icon-error"></i>
                  审核拒绝，点击
                  <el-button type="text" @click="torenzheng('new')">查看详情</el-button>
                </div>
              </div>
              <div class="concat">
                联系方式：<span v-if="status == '已认证'">{{ phone }}</span>
                <el-button
                  v-if="phoneEditVisible"
                  type="text"
                  icon="el-icon-edit-outline"
                  style="margin-left: 10px"
                  @click="changePhone"
                  >修改账号</el-button
                >
              </div>
              <div style="display: flex; margin-top: 10px">
                <div class="concat">
                  交易会员认证状态：
                  <el-button
                    :type="licenseStatus"
                    :icon="licenseIcon"
                    plain
                    round
                    size="mini"
                    @click="torenzheng('old')">
                    <span>{{ status }}</span>
                    <i class="el-icon-arrow-right el-icon--right"></i>
                  </el-button>
                </div>

                <!-- <div class="concat" style="margin-left: 10px">
                  中长期会员认证状态：
                  <el-button
                    :type="mineAuditStatusType"
                    :icon="mineAuditIcon"
                    plain
                    round
                    size="mini"
                    @click="torenzhengs">
                    <span>{{ mineAuditStatus }}</span>
                    <i class="el-icon-arrow-right el-icon--right"></i>
                  </el-button>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="xiangqing">订单详情</div> -->
        <div class="fenqu">
          <div @click="activeBlock(1)" :class="{ 'block-active': isActive == 1 }" class="block">
            <!-- <div>{{ guapaicaigouCount }}</div> -->
            <div class="block-name">挂牌采购</div>
            <div class="block-main">
              <div class="block-color">
                <i class="hy-icon-dingdan"></i>
              </div>
              <div class="block-nums">
                <p>订单数量</p>
                <div>{{ nums.listedProcurementNum }}</div>
              </div>
            </div>
          </div>
          <div @click="activeBlock(2)" :class="{ 'block-active': isActive == 2 }" class="block">
            <!-- <div>{{ guapaixiaoshouCount }}</div> -->
            <div class="block-name">挂牌销售</div>
            <div class="block-main">
              <div class="block-color">
                <i class="hy-icon-dingdan"></i>
              </div>
              <div class="block-nums">
                <p>订单数量</p>
                <div>{{ nums.listedForSaleNum }}</div>
              </div>
            </div>
          </div>

          <div @click="activeBlock(3)" :class="{ 'block-active': isActive == 3 }" class="block">
            <!-- <div>{{ jingjiacaigou }}</div> -->
            <div class="block-name">竞价采购</div>
            <div class="block-main">
              <div class="block-color">
                <i class="hy-icon-dingdan"></i>
              </div>
              <div class="block-nums">
                <p>订单数量</p>
                <div>{{ nums.biddingNum }}</div>
              </div>
            </div>
          </div>
          <div @click="activeBlock(4)" :class="{ 'block-active': isActive == 4 }" class="block">
            <!-- <div>{{ jingjiaxiaoshou }}</div> -->
            <div class="block-name">竞价销售</div>
            <div class="block-main">
              <div class="block-color">
                <i class="hy-icon-dingdan"></i>
              </div>
              <div class="block-nums">
                <p>订单数量</p>
                <div>{{ nums.auctionSaleNum }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 修改手机号 弹窗 -->
    <TelephoneEdit ref="telephoneEditRef" />
  </div>
</template>

<script>
import { getCompanyAuthDetail, orderNum } from "@/api/userCenters.js";
import { reqCompanyDetail } from "@/api/hy";
import TelephoneEdit from "./components/TelephoneEdit.vue";
import Vue from "vue";
import * as types from "@/store/action-types";

export default {
  components: {
    TelephoneEdit,
    //   readcrumb: () => import("../../components/breadcrumb"),
  },
  data() {
    return {
      guapaicaigouCount: 0,
      guapaixiaoshouCount: 0,
      jingjiacaigou: 0,
      jingjiaxiaoshou: 0,
      record: {},
      isActive: 1,
      /** 交易会员认证状态 */
      status: "",
      /** 交易会员认证按钮类型 */
      licenseStatus: "",
      /** 交易会员认证按钮图标 */
      licenseIcon: "",
      /** 中长期会员认证状态 */
      mineAuditStatus: "",
      /** 中长期会员认证按钮类型 */
      mineAuditStatusType: "",
      /** 中长期会员认证按钮图标 */
      mineAuditIcon: "",
      // breadcrumbDto: [
      //   { path: "/index", title: "首页" },
      //   { path: "/userIndex", title: "个人中心" },
      // ],
      /** 挂牌、竞价统计数据 */
      nums: {},
      /** 联系方式 */
      phone: "",
      /** 联系方式是否可以修改 */
      phoneEditVisible: false,
    };
  },
  created() {
    this.phone = window.localStorage.getItem("phone");
    // 获取数据
    this.getPages();
    // 获取企业认证详情
    this.getCompanyAuthDetail();
    /** 获取企业详情 */
    this.getCompanyDetail();
  },
  methods: {
    /** 修改手机号 */
    changePhone() {
      if (!this.beforhandle("personalCenter:personnelStructure:change")) return;
      this.$confirm("修改绑定的手机号?", "提示", {
        confirmButtonText: "继续修改",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$refs.telephoneEditRef.open();
      });
    },
    torenzheng(type) {
      if (!this.beforhandle("personalCenter:enterpriseCert")) return;
      this.$router.push({
        path: "/authentication",
        query: { type },
      });
    },
    torenzhengs() {
      this.$router.push({
        path: "/MediumTerm",
        query: {
          type: this.mineAuditStatus,
        },
      });
    },
    activeBlock(id) {
      this.isActive = id;
    },
    /** 获取分类合计数据 */
    getPages() {
      orderNum().then(res => {
        console.log(res);
        this.nums = res.data;
      });
    },

    /** 获取企业认证详情 */
    getCompanyAuthDetail() {
      getCompanyAuthDetail().then(res => {
        this.record = res.data;
        console.log(res.data.auditStatus);
        if (res.data.auditStatus == 0) {
          this.status = "审核中";
          this.licenseStatus = "warning";
          this.licenseIcon = "el-icon-warning";
        } else if (res.data.auditStatus == 1) {
          this.status = "已认证";
          this.licenseStatus = "success";
          this.licenseIcon = "el-icon-success";
        } else if (res.data.auditStatus == 2) {
          this.status = "审核拒绝";
          this.licenseStatus = "danger";
          this.licenseIcon = "el-icon-error";
        } else {
          this.status = "未认证";
          this.licenseStatus = "info";
          this.licenseIcon = "el-icon-error";
        }
        if (res.data.mineAuditStatus == 0) {
          this.mineAuditStatus = "待审核";
          this.mineAuditStatusType = "warning";
          this.mineAuditIcon = "el-icon-warning";
        } else if (res.data.mineAuditStatus == 1) {
          this.mineAuditStatus = "审核通过";
          this.mineAuditStatusType = "success";
          this.mineAuditIcon = "el-icon-success";
        } else if (res.data.mineAuditStatus == 2) {
          this.mineAuditStatus = "审核拒绝";
          this.mineAuditStatusType = "danger";
          this.mineAuditIcon = "el-icon-error";
        } else {
          this.mineAuditStatus = "未认证";
          this.mineAuditStatusType = "info";
          this.mineAuditIcon = "el-icon-error";
        }
        console.log(this.record);
      });
    },
    /** 获取企业详情 */
    async getCompanyDetail() {
      const res = await reqCompanyDetail({ id: Vue.ls.get(types.enterpriseId) });
      if (res.code && res.code != 0) {
        return this.$YTmsg(res.message || "获取企业信息失败", "error");
      }
      /** 主账号才能修改手机号 */
      if (this.phone == res.data.telephone) {
        this.phoneEditVisible = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.center {
  width: 1195px;
  display: flex;
  justify-content: flex-start;
  background: #f7f7f7;
  position: relative;
  .nav-title {
    position: absolute;
    top: 3px;
    left: 20px;
    font-size: 14px;
    color: #333333;
    span {
      margin: 0 10px;
    }
  }
  .left {
    width: 186px;
    margin: 20px;
    border: 1px solid #e5e5e5;
    border-top: 0;
    text-align: center;
    color: #666666;
    height: 663px;
    overflow: hidden;
    overflow-y: auto;
    .outer-box {
      background-color: #ffffff;
      padding-top: 12px;
    }

    .one {
      font-size: 18px;
      height: 47px;
      font-weight: 550;
      line-height: 47px;
      background: #f3f3f3;
      border-bottom: 1px solid #e5e5e5;
      border-top: 1px solid #e5e5e5;
    }

    .two {
      font-size: 16px;
      display: block;
      height: 40px;
      line-height: 40px;
      margin: 0 auto;
      width: 136px;
    }
    .outer-box1 {
      padding-top: 0;
      .two {
        font-size: 16px;
        font-weight: 550px;
        font-weight: 550;
      }
    }
    .two-active {
      height: 40px;
      background: linear-gradient(-45deg, #00a0ff, #0a65ff);
      box-shadow: 0px 5px 20px 0px rgba(143, 170, 249, 0.47);
      border-radius: 20px;
      line-height: 40px;
      color: #ffffff;
    }
    .three {
      font-size: 14px;
      display: block;
      height: 30px;
      line-height: 30px;
      margin: 0 auto;
      width: 136px;
      color: #666666;
    }
  }
  .right {
    margin: 20px;
    width: calc(100% - 300px);
    border: 1px solid #e5e5e5;
    background-color: #ffffff;
    .header {
      display: flex;
      border-bottom: 1px #c9c9c9 dashed;
      height: 218px;
      align-items: center;
      .img {
        width: 84px;
        height: 84px;
        margin-left: 50px;
        border: 1px solid #e5e5e5;
        border-radius: 50%;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .infos {
        display: flex;
      }
      .info {
        font-size: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        margin-left: 30px;
        color: #333333;
        height: 84px;
        .names {
          font-size: 18px;
        }
        .concat {
          font-size: 14px;
          display: flex;
          align-items: center;
        }
        .verification {
          margin-left: 24px;
          padding: 4px 12px;
          border-radius: 0px 0px 0px 0px;

          ::v-deep .el-button {
            padding: 0;
          }
        }
        .verification-under {
          background: #fffbe6;
          border: 1px solid #ffe58f;

          .el-icon-warning {
            color: #faad14;
          }
        }
        .verification-refuse {
          background: #fff1f0;
          border: 1px solid #fba39e;

          .el-icon-error {
            color: #f5222d;
          }
        }
        .el-button--mini,
        .el-button--mini.is-round {
          padding: 6px 10px;
          font-size: 14px;

          .el-icon--right {
            font-weight: 600;
          }
        }
      }
    }
    .xiangqing {
      margin: 20px 0;
      height: 50px;
      line-height: 50px;
      font-size: 30px;
      text-align: center;
    }
    .fenqu {
      display: flex;
      justify-content: space-between;
      font-size: 30px;
      padding: 15px 26px;
      flex-wrap: wrap;
      .block {
        height: 174px;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        margin-top: 27px;
        .block-main {
          display: flex;
          padding-top: 24px;
          padding-left: 32px;
          .block-color {
            width: 77.3px;
            height: 77.3px;
            border-radius: 50%;
            border: 1px solid #dddddd;
            display: flex;
            align-items: center;
            justify-content: center;
            i {
              font-size: 60px;
              color: #096cff;
            }
          }
          .block-nums {
            margin-left: 27px;
            p {
              font-size: 20px;
            }
            div {
              font-size: 30px;
              color: #ff0000;
              margin-top: 18px;
              span {
                font-size: 20px;
              }
            }
          }
        }

        .block-name {
          color: #333333;
          font-size: 18px;
          height: 46px;
          line-height: 46px;
          border-bottom: 1px solid #dddddd;
          padding-left: 18px;
          color: #333333;
          font-weight: bold;
        }
      }
      .block:hover {
        background: linear-gradient(-45deg, #00a0ff, #0a65ff);
        .block-name {
          color: #ffffff;
        }
        .block-color {
          border: 1px solid #ffffff !important;
          i {
            color: #ffffff !important;
          }
        }
        .block-over {
          background: linear-gradient(-45deg, #00a0ff, #0a65ff);
          color: #ffffff;
        }
        .block-nums {
          color: #ffffff !important;
        }
        .block-nums div {
          color: #ffffff !important;
        }
      }
    }
    .fenqu > div {
      width: 49.5%;
    }
  }
}
</style>
